import "bootstrap/dist/css/bootstrap.min.css";
import HowitWorks from "../../../components/modules/Vehicle/SellCarWorkFlow"
import SellCarForm from "../../../components/modules/Vehicle/SellCarForm";
import DocumentsRequired from "../../../components/modules/Vehicle/SellCarDocuments";
import Benefits from "../../../components/modules/Vehicle/SellCarBenefits";
import Testimonials from "../../../components/common/Testimonial";
import ContactUs from "../../../components/common/ContactUs";
import ParkAndSellBanner from "../../../components/common/ParkAndSellBanner";
import BuyCarBanner from "../../../components/common/BuyCarBanner";
import Faq from "../../../components/common/Faq";
import HTTP from "../../../config/axios"
import { useState, useEffect, useRef } from "react";
import { Carousel } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const SellCar = () => {

  const [faqContent, setFaqcontent] = useState('')
  const [isMobile, setIsMobile] = useState(false)
  const [isTablet, setIsTablet] = useState(false)
  const [isTabletPortrait, setIsTabletPortrait] = useState(false)

  useEffect(() => {

    const getCmsContent = async () => {
      let sellCarFaq = "sellcar-FAQ"
      const response = await HTTP.get(`/api/cms/fetch-one/${sellCarFaq}`);
      const { data: { status, data, msg, error } } = response
      setFaqcontent(data)
    }
    getCmsContent()

  }, []);


  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const isPortrait = height > width;
      const mobile = width <= 767;
      const tablet = width >= 768 && width <= 1199;
      const tabletPortrait = tablet && isPortrait;
      const tabletLandscape = tablet && !isPortrait;

      setIsMobile(mobile);
      setIsTablet(tabletLandscape);
      setIsTabletPortrait(tabletPortrait);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  return (
    <div className="App">
      <Carousel className="home-carousel" controls={false}>
        <Carousel.Item>
          {isMobile ? (
            <img
              className="d-block"
              src={`${process.env.REACT_APP_CLOUDFRONT_URL}/sell_car_banner/Sell-car-page-i20-390 × 920.jpg`}
              alt="First slide"
              style={{
                width: '100%',
                maxHeight: '100vh',
                objectFit: 'fill',
                objectPosition: 'center'
              }}
            />
          ) : isTabletPortrait ? (
            <img
              className="d-block"
                src={`${process.env.REACT_APP_CLOUDFRONT_URL}/sell_car_banner/Sell-car-page-i20-820×1286.png`}
              alt="First slide"
              style={{
                width: '100%',
                maxHeight: '80vh',
                objectFit: 'fill',
                objectPosition: 'center'
              }}
            />
          ) : isTablet ? (
            <img
              className="d-block"
              src={`${process.env.REACT_APP_CLOUDFRONT_URL}/sell_car_banner/Sell-car-page-i20-844×425.jpg`}
              alt="First slide"
              style={{
                width: '100%',
                maxHeight: '70vh',
                objectFit: 'fill',
                objectPosition: 'center'
              }}
            />
          ) : (
            <img
              className="d-block"
              src={`${process.env.REACT_APP_CLOUDFRONT_URL}/sell_car_banner/Sell-car-page-i20-1200×600.jpg`}
              alt="First slide"
            />
          )}
        </Carousel.Item>

        <Carousel.Item>
          {isMobile ? (
            <img
              className="d-block"
              src={`${process.env.REACT_APP_CLOUDFRONT_URL}/sell_car_banner/Sell-car-page-Swift-390×920.jpg`}
              alt="Second slide"
              style={{
                width: '100%',
                maxHeight: '100vh',
                objectFit: 'fill',
                objectPosition: 'center'
              }}
            />
          ) : isTabletPortrait ? (
            <img
              className="d-block"
                src={`${process.env.REACT_APP_CLOUDFRONT_URL}/sell_car_banner/Sell-car-page-Swift-820×1286.png`}
              alt="Second slide"
              style={{
                width: '100%',
                maxHeight: '80vh',
                objectFit: 'fill',
                objectPosition: 'center'
              }}
            />
          ) : isTablet ? (
            <img
              className="d-block"
              src={`${process.env.REACT_APP_CLOUDFRONT_URL}/sell_car_banner/Sell-car-page-Swift-844×425.jpg`}
              alt="Second slide"
              style={{
                width: '100%',
                maxHeight: '70vh',
                objectFit: 'fill',
                objectPosition: 'center'
              }}
            />
          ) : (
            <img
              className="d-block"
              src={`${process.env.REACT_APP_CLOUDFRONT_URL}/sell_car_banner/Sell-car-page-Swift-1200×600.jpg`}
              alt="Second slide"
            />
          )}
        </Carousel.Item>
      </Carousel>
      <SellCarForm />
      <HowitWorks />
      <Benefits />
      <DocumentsRequired />
      <ParkAndSellBanner />
      <Testimonials />
      <BuyCarBanner />
      {faqContent && <Faq cmsContent={faqContent} cmsType="all-sell-faq" />}
      <ContactUs />
    </div>
  );
}

export default SellCar;